import { useState } from 'react';
import type { Faq } from '@/mocks/site';

interface FaqAccordionProps {
  items: Faq[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200/80 rounded-lg border border-background-200/80 bg-background-50 overflow-hidden">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                aria-expanded={isOpen}
                onClick={() => setOpenIndex(isOpen ? null : index)}
                className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-5 text-left cursor-pointer hover:bg-background-100/70 transition-colors"
              >
                <span className="font-heading text-sm md:text-base font-bold text-foreground-950">
                  {item.q}
                </span>
                <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-lg text-primary-600 shrink-0`} />
              </button>
            </h3>
            <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
              <div className="overflow-hidden">
                <p className="px-5 md:px-6 pb-5 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}